import React from "react";
import { uri } from "../../../help/Api";
import useFetchObjectByPost from "../../../components/Hooks/useFetchObjectByPost";
import { useEffect } from "react";
import BackdropScI from "../../../services/BackdropScI";
import Customers from "./customers";
import useFetchURL from "../../../components/Hooks/useFetchURL";
import {URL} from '../../../api/customer';
import { Dialog } from "@material-ui/core";
import { useState } from "react";
import { sto } from "../../../Context/InshData";
import LoadingPage from "../../../services/LoadingPage";
export default function CustomerDialogData(props){

    const {open, onClose, type,onSave ,custData } = props;
    const tb = {
        wait:true,
        Areas:true,
        Cities:true, Countries:true, 
        salesmen: true,
        ActsCust: true,
        defaultSalesUser:true,
        parms:{
            iempid: sto.empi,
             icustmtype: type,

    },
        autos:{Areas:true, Cities:true, Countries:true, salesmens: true,}
    }
    const url = uri+'Res';

    const {object:data, fetching: fetchinData, fetch} =  useFetchObjectByPost(url, tb);
    const {data: newAccount, fetching, fetchURL} = useFetchURL({...{
        url: URL+`/newAccount?typeAccount=${type}`
    }});
    const tb2 = {
        wait:true,
        defaultSalesUser:true,
        UsersA:true,
        Levels:true,
        stor: sto,
        parms:{
            iempid: sto.empi,
            branch:sto.branchi,
        },
    };

    const { object: DefaultSalesMan} = useFetchObjectByPost(
        uri + "GetD",
        tb2,
      );
  
    useEffect(()=>{
        console.log("the type is", type,DefaultSalesMan)
    })
    if(fetchinData || !data?.ActsCust  ||!DefaultSalesMan.Users || !newAccount || fetching)
        // if(fetchinData || !data?.ActsCust || !newAccount || fetching)

      //if(fetchinData || !data?.ActsCust || !newAccount || fetching)
      return <LoadingPage />;

        // return <Dialog fullScreen open={open} onClose={onClose}> </Dialog>
    return (
        <Dialog fullScreen open={open} onClose={onClose}>
            <Customers
        {...{
            data:{...data, Acts: data?.ActsCust},
            newAccount,
            fetchinData,
            fetchURL,
            isDialog: true,
            type,
            onClose,
            onSave,
            defaultSalman:{id:DefaultSalesMan?.salesuser?.id,name:DefaultSalesMan?.salesuser?.name,i:0,isDefault:false},
            isData:true,
            custData,
            OptionsUsers:DefaultSalesMan?.Users,
            Levels:DefaultSalesMan?.Levels??[],
        }}/>
        </Dialog>
        
    )
}

   